import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";


// Thunk for getting Add banners
export const getAllCareers = createAsyncThunk(
    'home/get-career',
    async (_, { rejectWithValue }) => {
        try {
            const careerData = await GET(API.GET_Careers);
            return careerData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const addResume = createAsyncThunk(
    'home/add-resume',
    async (data, { rejectWithValue }) => {
        try {
            console.log(data, 'datadatadata');

            const careerData = await POST(API.GET_Careers, data);
            return careerData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const getCareerById = createAsyncThunk(
    'home/add-careerid',
    async (id, { rejectWithValue }) => {
        try {
            const careerData = await GET(API.GET_Career + `/${id}`);
            return careerData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


// Create the slice
const careerSlice = createSlice({
    name: "career",
    initialState: {
        careers: [],
        name: '',
        image: '',
        description: '',
        addCareer: [],
        getCareerById: {},
        error: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(getAllCareers.pending, (state) => {
                state.status = 'loading';
                console.log('State after pending', state);
            })
            .addCase(getAllCareers.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.careers = action.payload?.data || [];
                
            })
            .addCase(getAllCareers.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                console.log('State after rejected', state);
            })


            .addCase(getCareerById.pending, (state) => {
                state.status = 'loading';
                console.log('State after pending', state);
            })
            .addCase(getCareerById.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.getCareerById = action.payload?.data || [];
                
            })
            .addCase(getCareerById.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                console.log('State after rejected', state);
            })


            .addCase(addResume.pending, (state) => {
                state.status = 'loading';
                console.log('State after pending', state);
            })
            .addCase(addResume.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addCareer = action.payload?.data || [];
                
            })
            .addCase(addResume.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                console.log('State after rejected', state);
            });

    },
});

export default careerSlice.reducer;


